/**
 * Поле пароля с глазом внутри (22.10.2026).
 *
 * Раньше «Показать пароль» было отдельной галочкой под полем и стояло в одном
 * ряду с согласиями — читалось как ещё одно согласие. Глаз в поле — то, что
 * человек ждёт по любому другому приложению.
 */
import { useState } from 'react';
import { Icon } from './icon.js';

export function PasswordField({ value, onChange, autoComplete, autoFocus }: {
  value: string;
  onChange: (value: string) => void;
  autoComplete: 'new-password' | 'current-password';
  autoFocus?: boolean;
}) {
  const [show, setShow] = useState(false);
  return (
    <span className="pwd">
      <input value={value} onChange={(e) => onChange(e.target.value)}
        type={show ? 'text' : 'password'} autoComplete={autoComplete} autoFocus={autoFocus} />
      {/* Фокус остаётся в поле: иначе на телефоне прячется клавиатура. */}
      <button type="button" className="pwd-eye" aria-pressed={show}
        aria-label={show ? 'Скрыть пароль' : 'Показать пароль'}
        onPointerDown={(e) => e.preventDefault()}
        onClick={() => setShow((v) => !v)}>
        <Icon name={show ? 'eye-slash' : 'eye'} size={18} />
      </button>
    </span>
  );
}
